import MainChatScreenIcon from "./MainChatScreenIcon";

const ChatIcons={
 MainChatScreenIcon
}

export default ChatIcons;